import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { MaterialModule } from '../material.module';
import { EnumToArrayPipe } from './pipes/enum-to-array-pipe';
import { AddTargetBlankNoOpenerDirective } from './directives/add-target-blank-no-opener.directive';
import { IntlTelNumberInputComponent } from './components/intl-tel-number-input/intl-tel-number-input.component';
import { TranslateModule } from '@ngx-translate/core';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AnimateSpinButtonComponent } from './components/loading/animate-spin-button/animate-spin-button.component';
import { ButtonSpinnerComponent } from './components/loading/button-spinner/button-spinner.component';
import { ContentSpinnerComponent } from './components/loading/content-spinner/content-spinner.component';
import { SwiperDirective } from './directives/swiper.directive';
import { BlockUiComponent } from './components/block-ui/block-ui.component';
import { PopupModalComponent } from './components/popup/popup-modal.component';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { RecursiveMatSelectComponent } from './components/recursive-mat-select/recursive-mat-select.component';
import { ConfirmationPopupComponent } from './components/confirmation-popup/confirmation-popup.component';
import { ReminderPopupComponent } from './components/reminder-popup/reminder-popup.component';
import { AskPodPopupComponent } from './components/askpod-popup/askpod-popup.component';
import { AskPodDowntimePopupComponent } from './components/askpod-downtime-popup/askpod-downtime-popup.component';
import { AskPodTrialEndedPopupComponent } from './components/askpod-trial-ended-popup/askpod-trial-ended-popup.component';
import { DurationFormatPipe } from './pipes/duration-format.pipe';
import { FavouriteComponent } from './components/favourite/favourite.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { ProgramCardComponent } from './components/program-card/program-card.component';
import { RouterModule } from '@angular/router';
import { CountdownModule } from 'ngx-countdown';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PDFViewerComponent } from './components/pdf-viewer/pdf-viewer.component';
import { EmptyResultComponent } from './components/empty-result/empty-result.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DatepickerComponent } from './components/datepicker/datepicker.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilesizePipe } from './pipes/file-size.pipe';
import { CourseCardComponent } from './components/course-card/course-card.component';
import { FeedbackPopupComponent } from './components/feedback-popup/feedback-popup.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { GeneralSearchDropdownComponent } from './components/general-search-dropdown/general-search-dropdown.component';
import { SuccessfulWithIconPopupComponent } from './components/successful-with-icon-popup/successful-with-icon-popup.component';
import { EmptyVideoPlaceholderComponent } from './components/empty-video-placeholder/empty-placeholder.component';
import { HighlightTextPipe } from './pipes/highlight-text.pipe';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { JourneyTipsPopupComponent } from './components/journey-tips-popup/journey-tips-popup.component';
import { ProgressIndicatorComponent } from '../../../features/home/page/homepage/progress-indicator/progress-indicator.component';
import { CreditCardFormatDirective } from 'angular-cc-library';
import { MultipleDeviceDetectedPopupComponent } from './components/multiple-device-detected-popup/multiple-device-detected-popup.component';
import { YearPickerComponent } from './components/year-picker/year-picker.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ProgramButtonComponent } from './components/program-button/program-button.component';
import { SummernoteEditorComponent } from './components/summernote-editor/summernote-editor.component';
import { SearchComponent } from '../../components/shared/search/search.component';
import { DropdownHierarchicalMultiselectComponent } from '../../components/shared/dropdown-hierarchical-multiselect/dropdown-hierarchical-multiselect.component';
import { EInvoicingBannerComponent } from './components/e-invoicing-banner/e-invoicing-banner.component';
import { PrefixDropdownComponent } from './components/prefix-dropdown/prefix-dropdown.component';

@NgModule({
    declarations: [
        AddTargetBlankNoOpenerDirective,
        AnimateSpinButtonComponent,
        AskPodPopupComponent,
        AskPodDowntimePopupComponent,
        AskPodTrialEndedPopupComponent,
        BlockUiComponent,
        ButtonSpinnerComponent,
        ConfirmationPopupComponent,
        ContentSpinnerComponent,
        CourseCardComponent,
        DatepickerComponent,
        DropdownComponent,
        DropdownHierarchicalMultiselectComponent,
        DurationFormatPipe,
        EInvoicingBannerComponent,
        EmptyResultComponent,
        EmptyVideoPlaceholderComponent,
        EnumToArrayPipe,
        FavouriteComponent,
        FeedbackPopupComponent,
        FilesizePipe,
        GeneralSearchDropdownComponent,
        HighlightTextPipe,
        IntlTelNumberInputComponent,
        JourneyTipsPopupComponent,
        MultipleDeviceDetectedPopupComponent,
        PaginationComponent,
        PDFViewerComponent,
        PopupModalComponent,
        PrefixDropdownComponent,
        ProgramButtonComponent,
        ProgramCardComponent,
        ProgressBarComponent,
        ProgressIndicatorComponent,
        RecursiveMatSelectComponent,
        ReminderPopupComponent,
        SafeHtmlPipe,
        SearchComponent,
        SuccessfulWithIconPopupComponent,
        YearPickerComponent,
        SummernoteEditorComponent,
    ],
    imports: [
        AngularEditorModule,
        CommonModule,
        CountdownModule,
        CreditCardFormatDirective,
        DigitOnlyModule,
        FormsModule,
        FullCalendarModule,
        InfiniteScrollDirective,
        MaterialModule,
        NgxExtendedPdfViewerModule,
        NgxMaskDirective,
        NgxMaskPipe,
        ReactiveFormsModule,
        RouterModule,
        SwiperDirective,
        TranslateModule,
    ],
    exports: [
        AddTargetBlankNoOpenerDirective,
        AngularEditorModule,
        AnimateSpinButtonComponent,
        AskPodPopupComponent,
        AskPodDowntimePopupComponent,
        AskPodTrialEndedPopupComponent,
        BlockUiComponent,
        ButtonSpinnerComponent,
        CountdownModule,
        ContentSpinnerComponent,
        CourseCardComponent,
        CreditCardFormatDirective,
        DatepickerComponent,
        DigitOnlyModule,
        DropdownComponent,
        DropdownHierarchicalMultiselectComponent,
        DurationFormatPipe,
        EInvoicingBannerComponent,
        EmptyResultComponent,
        EmptyVideoPlaceholderComponent,
        EnumToArrayPipe,
        FavouriteComponent,
        FilesizePipe,
        FormsModule,
        FullCalendarModule,
        GeneralSearchDropdownComponent,
        HighlightTextPipe,
        InfiniteScrollDirective,
        IntlTelNumberInputComponent,
        JourneyTipsPopupComponent,
        MultipleDeviceDetectedPopupComponent,
        NgxExtendedPdfViewerModule,
        NgxMaskDirective,
        NgxMaskPipe,
        PaginationComponent,
        PDFViewerComponent,
        PopupModalComponent,
        PrefixDropdownComponent,
        ProgramButtonComponent,
        ProgramCardComponent,
        ProgressBarComponent,
        ProgressIndicatorComponent,
        ReactiveFormsModule,
        RecursiveMatSelectComponent,
        SafeHtmlPipe,
        SearchComponent,
        SwiperDirective,
        YearPickerComponent,
        SummernoteEditorComponent,
    ],
    providers: [provideNgxMask()],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule { }
